import type { RouteConfig } from 'vue-router'

export const standaloneRoutes: RouteConfig[] = []
